import React, { Component } from "react";
import styles from "./errorMap.module.scss";

class Map extends Component {
  state = {
    loading: true
  };

  render() {
    return (
      <div className={styles.trackingNW}>
        <span>
          &quot; Oops! Your Booking is Canncelled. Please contact Customer
          Support
        </span>
      </div>
    );
  }
}

export default Map;
